import { LGraphContainer } from './lGraphContainer';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';

export const UnpoweredDays = ({ scoreCard, scoreDes, Styled }) => {
  const { t } = useTranslation();
  return (
    <div className="grid-item2 topMargin">
      <div className="part1">
        <LGraphContainer
          {...{
            title: t('newScoreCard.poweredDays'),
            data: scoreCard?.unpoweredDays,
            small: true,
            info: (
              <p>
                <Trans i18nKey="scorecard.unpoweredDaysGraphDesc" />
              </p>
            ),
            cardInfo: t('scorecard.unpoweredDaysTotalDesc'),
            scoreDes,
            Styled,
          }}
        />
      </div>
      <Divider className="divider-style2" orientation="vertical" />
      <div className="part2">
        <LGraphContainer
          {...{
            title: t('scorecard.radiusViolations'),
            data: scoreCard?.radiusViolations,
            small: true,
            info: (
              <p>
                <Trans i18nKey="scorecard.radiusViolationGraphDesc" />
              </p>
            ),
            cardInfo: t('scorecard.radiusViolationTotalDesc'),
            scoreDes,
            Styled,
          }}
        />
      </div>
    </div>
  );
};
